import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from './useAuth';
import { ShellSpinner } from '@/components/ShellSpinner';

interface RequirePermissionProps {
  /** Permission claim required, matched case-insensitively. */
  permission?: string;
  /** Role required. Accepts several; holding any one of them is enough. */
  roles?: string[];
}

/**
 * Authorization guard, layered inside <RequireAuth>. This mirrors, rather than
 * replaces, the `[Authorize]` attributes on the controllers: the server stays
 * the enforcement point, and this only decides what to render.
 */
export function RequirePermission({ permission, roles }: RequirePermissionProps) {
  const { isLoading, hasPermission, hasRole } = useAuth();

  if (isLoading) return <ShellSpinner />;

  const permitted =
    (permission == null || hasPermission(permission)) &&
    (roles == null || roles.length === 0 || roles.some((role) => hasRole(role)));

  if (!permitted) return <Navigate to="/auth-accessdenied" replace />;

  return <Outlet />;
}
